module.exports = __webpack_public_path__ + "img/main-banner-ua.50e7a0af.png";